import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']
  static values = {
    maxSize: { type: Number, default: 25000000 }, // Set default maximum size to 25mb. Use values to override if needed
    errorMessage: {
      type: String,
      default:
        'This file is too large to upload. The maximum supported file size is 25 MB.',
    }, // override if you want to display a different error
  }

  // initializations are done here, after connecting
  connect() {}

  // validate that file size is less that configured max size
  validateFileSize() {
    // We don't need to do anything if the file is uploaded to S3, because Uppy checks the file size
    if (this.inputTarget.dataset.fileUploadTarget === 'input') {
      return
    }
    const file = this.inputTarget.files[0]

    if (file?.size > this.maxSizeValue) {
      alert(this.errorMessageValue)
      this.inputTarget.value = null
    }
  }
}
